export default "__VITE_ASSET__fb1e098d__"